// extracted by mini-css-extract-plugin
module.exports = {"formRecuperar":"style_formRecuperar__35G-A","alertSuccess":"style_alertSuccess__3LLvm"};